'use client';

import BaseModal from '@/components/modal/lib/BaseModal';
import PriveeKeyholeMaroon from 'public/img/icon/keyhole-red.png';
import Image from 'next/image';
import Text from '@/components/common/Text/Text';

import './PriveeExpressedInterestThankYouModal.style.scss';
import Button from '@/components/common/Button/Button';

type InterestedInPriveeThankYouModalProps = {
  onClose: () => void;
  closeButtonText?: string;
};

function InterestedInPriveeThankYouModal(
  props: InterestedInPriveeThankYouModalProps
) {
  const { onClose, closeButtonText } = props;

  return (
    <BaseModal
      className='interested-in-privee-thank-you-modal'
      onClose={() => onClose()}
    >
      <div className='keyhole-img-container'>
        <Image
          src={PriveeKeyholeMaroon}
          alt='Maroon keyhole silhouette'
          width={26}
          height={53}
        />
      </div>
      <div className='thank-you-text-container'>
        <p className='thank-you-text'>
          Thank you for your
          <br />
          interest in R&eacute;serv&eacute;.
        </p>
        <Text className='be-in-touch-text'>
          We&apos;ll be in touch if you&apos;re
          <br />
          selected for an invitation.
        </Text>
      </div>
      <Button
        variant='dark'
        size='small'
        onClick={() => onClose()}
      >
        {closeButtonText ?? 'Back to Vivrelle'}
      </Button>
    </BaseModal>
  );
}

export default InterestedInPriveeThankYouModal;
